let resizeTimer,
    lightGallerySettings = {
        autoplay: false,
        autoplayControls: false,
        thumbnail: false,
        download: false,
        share: false,
        fullScreen: false,
        videoMaxWidth: "1140px",
        iframeMaxWidth: "100%",
        enableDrag: true,
        enableTouch: true,
        zoom: false
    },
    tippySettings = {
        theme: 'black',
        arrow: false,
        allowHTML: true,
        interactiveBorder: 25,
        appendTo: document.body,
        placement: 'top-start',
        popperOptions: {
            modifiers: [{
                name: 'offset',
                options: {
                    offset: ({ placement, reference, popper }) => {
                        if (['top-start', 'bottom-start'].includes(placement)) {
                            return [reference.width / 2, 10];
                        }
                        else if (['top-end', 'bottom-end'].includes(placement)) {
                            return [reference.width / 2 * -1, 10];
                        }
                        else {
                            return [0, 10];
                        }
                    },
                },
            }],
        }
    };

function checkResolution(query) {
    let active = false;

    if (!query) {
        return true;
    }

    for (let value of query.split(";")) {
        if ($(".c-var ." + value + "-is-visible").is(":visible")) {
            active = true;
        }
    }

    return active;
}

function toggleElem($elem) {
    const $trigger = $elem,
        $target = $('.js-target-' + $elem.data('target'));

    if ($target.hasClass('is-active')) {
        $trigger.removeClass('is-active');

        $target
            .slideUp(250)
            .removeClass('is-active');
    } else {
        $trigger.addClass('is-active');

        $target
            .slideDown(250)
            .addClass('is-active');
    }
}

function toggleHeaderElem(object) {
    if (object.active) {
        hideElem(object);
    } else {
        showElem(object);
    }
}

function showElem(object) {
    const isAutocomplete = object == autocomplete;

    if (!object.keepActive && activeElement && activeElement.active && (activeElement != search || !isAutocomplete)) {
        hideElem(activeElement);
    }

    if (!isAutocomplete) {
        object.trigger.addClass('is-active');
        object.elem.addClass('is-active');
    }

    if (object.overlay) {
        showOverlay(250, object.allowScroll);
    }

    if (object.callback && object.callback.show) {
        object.callback.show();
    }

    object.active = true;

    activeElement = object;
}

function hideElem(object) {
    const isAutocomplete = object == autocomplete;

    if (isAutocomplete && checkResolution('cxs;xs')) {
        hideElem(search);
    }

    if (!isAutocomplete) {
        object.trigger.removeClass('is-active');
        object.elem.removeClass('is-active');
    }

    if (object.overlay) {
        hideOverlay();
    }

    if (object.callback && object.callback.hide) {
        object.callback.hide();
    }

    object.active = false;
}

document.addEventListener('lazybeforeunveil', function(e){
    const bg = e.target.getAttribute('data-bg');

    if (bg) {
        e.target.style.backgroundImage = `url(${bg})`;
    }
});

document.addEventListener('lazyloaded', function(e){
    const isLazySlider = $(e.target).hasClass('is-lazy-slider');

    if (isLazySlider) {
        Event.dispatch('LazySlider.loaded');
    }
});

function buildTippy() {
    $('.js-tippy-black').each(function() {
        if (!this._tippy) {
            tippy(this, tippySettings);
        }
    });

    $('.js-tippy-interactive').each(function() {
        if (!this._tippy) {
            tippy(this, Object.assign(tippySettings, {
                interactive: true,
                hideOnClick: false,
                offset: [1, 10],
                popperOptions: {}
            }));
        }
    });
}

function calculateViewportUnits() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

calculateViewportUnits();

function renderMultiselect() {
    $('.c-form__item--select select').not('.without-initialize').not('.is-loaded').each(function() {
        const options = {
                templates: {
                    button: '<button type="button" class="multiselect dropdown-toggle" data-toggle="dropdown"><i class="fa fa-chevron-down is-on-left"></i><span class="multiselect-selected-text"></span></button>'
                },
                buttonClass: 'c-btn has-icon',
                enableHTML: true
            },
            $select = $(this);

        // if (/country_id/i.test($select.attr('name'))) {
            options.maxHeight = 185;
        // }

        $select.multiselect(options);
        $select.addClass('is-loaded');
    });
}

function updateProductCartQuantityTooltip(quantity, productId = null) {
    const $cartCount = $(`.js-product-cart-count[data-id="${productId}"]`);

    if (!$cartCount.length) {
        return;
    }

    $cartCount.closest('.js-product-cart-holder').toggleClass('is-in-cart', quantity > 0);

    if (quantity > 0) {
        const template = $cartCount.data('template'),
            content = template.replace(':inCartCount', quantity);

        $cartCount.removeClass('is-hidden');

        $cartCount.each(function() {
            if (this._tippy) {
                this._tippy.setContent(content);
            } else {
                $(this)
                    .addClass('js-tippy-black')
                    .attr('data-tippy-content', content)
                    .data('tippy-content', content);
            }
        });
    } else {
        $cartCount.addClass('is-hidden');
    }
}

function processProductCartQuantityTooltip(products) {
    if (!products) {
        return;
    }

    $('.js-product-cart-count').addClass('is-hidden');
    $('.js-product-cart-holder').removeClass('is-in-cart');

    for (let productId in products) {
        let product = products[productId];

        updateProductCartQuantityTooltip(product.quantity, product.id);
    }

    buildTippy();
}

Event.on('Cart.product.after_add', function (response) {
    if (!response || !response.status) {
        return;
    }

    processProductCartQuantityTooltip(response.products);
});

Event.on('Cart.removedProduct', function (data) {
    if (!data || !data.response || !data.response.status) {
        return;
    }

    processProductCartQuantityTooltip(data.response.products);
});

Event.on('Cart.fetchedProducts', function (data) {
    if (!data) {
        return;
    }

    const response = data.response;

    if (!response || !response.status || !response.data) {
        return;
    }

    processProductCartQuantityTooltip(response.data.items);
});

RshopApp.$mount('.l-header');

$(function() {
    renderMultiselect();
    buildTippy();
    calculateViewportUnits();

    $(window).on('resize', function(e) {
        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(function() {
            Event.dispatch('Window.resized');

            calculateViewportUnits();
        }, 250);
    });

    $('.modal').on('show.bs.modal', function () {
        setTimeout(function() {
            freezeScroll();
        }, 0)
    });

    $('.modal').on('hidden.bs.modal', function () {
        unfreezeScroll();

        setTimeout(() => {
            document.body.style.removeProperty('padding-right');
        }, 0)
    });

    $('.js-toggle').on('click', function(event) {
        event.preventDefault();

        toggleElem($(this));
    });

    $('.js-anchor').on('click', function(event) {
        event.preventDefault();

        let href = $(this).attr('href');

        if (!href) {
            href = $(this).data('href');
        }

        if (!href) {
            return false;
        }

        slideTo($(href), 25, 300);
    });

    if (document.querySelector('.js-moc-prices')) {
        document.querySelector('.js-moc-prices').addEventListener('change', function() {
            this.closest('form').submit();
        });

        document.querySelectorAll('.js-moc-prices').forEach(checkbox => {
            checkbox.addEventListener('change', function() {
                this.closest('form').submit();
            });
        });
    }

    $('.js-discount-toggle').on('click', function() {
        var inputTarget = $(this).data('inputTarget');
        var $form = $(this).closest('form');

        if (!$(this).hasClass('c-btn--primary')) {
            $(this).addClass('c-btn--primary');
        }

        $(this).removeClass('c-btn--ghost');

        $form.find('[name="' + inputTarget + '"]').parent().removeClass('hidden');
        $form.find('[name="discount_type"]').val(inputTarget);

        $form.find('.js-discount-toggle').not(this).each(function() {
            $(this).removeClass('c-btn--primary');

            if (!$(this).hasClass('c-btn--ghost')) {
                $(this).addClass('c-btn--ghost');
            }

            $('[name="' + $(this).data('inputTarget') + '"]').parent().addClass('hidden');
        });
    });

    $('.js-change-product-price').on('submit', function(event) {
        event.preventDefault();

        Form.ajaxPost($(this), function(response) {
            if (response.status) {
                window.location.reload();
            } else {
                Eshop.alert(response.message, {type: 'error'});
            }
        }, 'json');
    });
});


function checkCartBeforeSubmit(event, form, productId) {
    event.preventDefault();
    const $form = $(form);
    const $submit = $form.find('button[type="submit"]');
    $submit.addClass('is-loading');
    const quantity = $form.find('[name=quantity]').val();
    const url = '/add-item/' + productId;

    Cart.getItemsRequest((res) => {
        $submit.removeClass('is-loading');

        const isInCart = Object.values(res.data.items).some((item) => item.id == productId);

        if (isInCart) {
            $('form[name=form-cart-check]').attr('action', url);
            $('form[name=form-cart-check]').attr('data-redirect', url);

            const $modalForm = $('form[name=form-cart-check]');
            $modalForm.find('[name=quantity]').val(quantity);
            $("#cart-check").modal("show");

            const submitButton = document.querySelector('.js-cart-check-submit-btn');
            if (submitButton) {
                closeCheckCartModal(submitButton);
            }

        } else {
            Cart.addItem(form)
        }
    });

    return false;
}

function closeCheckCartModal(submitButton) {
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.attributeName === "class") {
                if (!submitButton.classList.contains("is-loading")) {
                    $("#cart-check").modal("hide");
                    observer.disconnect();
                }
            }
        });
    });

    observer.observe(submitButton, { attributes: true });
}